import { components, paths } from "@securityjourney/svc-code-sub/src/gen/code_sub";

import { OpenApiFetchWrapper, type ServiceResponse } from "./openApiFetchWrapper";

export type CodeSubmission = components["schemas"]["securityjourney.proto.code_sub.CodeSubmission"];
export type RetrieveCodeSubmissionsRequest =
  components["schemas"]["securityjourney.proto.code_sub.RetrieveCodeSubmissionRequest"];
export type CodeSubmissions = {
  userCodeSubmissions?: components["schemas"]["securityjourney.proto.code_sub.CodeSubmission"][];
};
export type CodeSubTestResult = components["schemas"]["securityjourney.proto.code_sub.TestResult"];
export type CodeSubVolume = components["schemas"]["securityjourney.proto.code_sub.Volume"];

class CodeSubClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super();
  }

  async retrieveCodeSubmission(
    req: RetrieveCodeSubmissionsRequest
  ): Promise<ServiceResponse<CodeSubmissions>> {
    return await this.get("/svc/code-sub/submissions", {
      params: {
        query: {
          lessonId: req.lessonId,
          lessonVersion: req.lessonVersion,
          limit: req.limit,
          since: req.since,
          until: req.until,
        } as Record<string, unknown>,
      },
    } as any);
  }

  async retrieveCodeSubmissionsAdmin(
    email: string,
    until?: Date
  ): Promise<ServiceResponse<CodeSubmissions>> {
    const encodedEmail = btoa(
      String.fromCharCode(
        ...new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(email)))
      )
    );
    const params = {
      query: {
        email: encodedEmail,
        until: until ? until.toISOString() : undefined,
      },
    };
    const response = await this.get("/svc/code-sub/submissions/admin", { params });
    return response;
  }
}

let codeSubClientInstance: CodeSubClient | null = null;

export const getCodeSubClient = (): CodeSubClient => {
  if (!codeSubClientInstance) {
    codeSubClientInstance = new CodeSubClient();
  }
  return codeSubClientInstance;
};
